import formModel from './formModel';

const {
    firstName,
    lastName,
    idNumber,
    email,
    contactNumber,
    companyName,
    registeredCiaLA,
} = formModel;

const initialValues = {
    [firstName.name]: '',
    [lastName.name]: '',
    [idNumber.name]: '',
    [email.name]: '',
    [contactNumber.name]: '',
    [companyName.name]: '',
    [registeredCiaLA.name]: '',
};

export default initialValues;
